import BillingEstimateTableMobile from './BillingEstimateTableMobile'
export default BillingEstimateTableMobile